import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import React, { useContext, useEffect, useState } from "react";
import MDSelectBox from "components/MDSelectBox";
import { useFormik } from "formik";
import { initialValues } from "./Schemas/initialValue";
import { validationSchema } from "./Schemas/validation";
import { ModalContext } from "context/ModalContext";
import PropTypes from "prop-types";
import { LoginFormContext } from "context/LoginFormContext";
import { advertisementAdd } from "Apis/advertisement";
import { updateAdvertisement } from "Apis/advertisement";
import ImageUploader from "components/MDImageUploader";
import { AdvertisementContext } from "context/AdvertisementContext";
import MDTextField from "components/MDTextField";
import SubmitButton from "components/SubmitButton";
import { statusData } from "helpers/constant";

const AdvertisementForm = ({ getAdvertisementList }) => {
  const { editData, getEventApi, eventDataList, setEventDataList, advertisementPage, jsonListing } =
    useContext(AdvertisementContext);
  const { setNotification, profileImage, setProfileImage } = useContext(LoginFormContext);
  const [status, setStatus] = useState({
    label: "Inactive",
    value: "0",
  });
  const [page, setPage] = useState("");
  const { setOpen, formIsEdit } = useContext(ModalContext);
  const [eventData, setEventData] = useState([]);

  //setData in Formik...
  const setDataInFormik = async () => {
    formik.setValues(editData);
    const adIds = editData?.event_advertisements?.map((ad) => ad.event_id);
    formik.setFieldValue("event_advertisements", adIds);
    setEventData(
      editData?.event_advertisements?.map((data) => ({
        id: data.event.id,
        label: data.event.title,
      }))
    );
    formik.setFieldValue(
      "advertisement_images",
      editData?.advertisement_images[0]?.image.split("/").pop()
    );
    setProfileImage({
      url: editData?.advertisement_images[0]?.image || null,
      name: null,
    });
  };

  const getStatusLabel = (id) => {
    const status = statusData.find((item) => item.value == id);
    return status ? status.label : "-";
  };

  useEffect(() => {
    jsonListing();
    getEventApi();
    if (formIsEdit) {
      setDataInFormik();
      setPage(editData?.page);
      setStatus({ label: getStatusLabel(editData?.is_active), value: editData?.is_active });
    } else if (formIsEdit === false) {
      setProfileImage({
        url: null,
        name: null,
      });
    }
  }, []);

  //HandleSubmit Form
  const handleSubmit = async (values) => {
    if (!formIsEdit) {
      let response = await advertisementAdd(values);
      if (response?.status === 200) {
        getAdvertisementList();
        setOpen(false);
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response?.data?.message,
          open: true,
        });
      }
    } else {
      let response = await updateAdvertisement(values);
      if (response?.status === 200) {
        getAdvertisementList();
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response?.data?.message,
          open: true,
        });
        setOpen(false);
      } else {
        setNotification({
          color: "error",
          icon: "cancel",
          title: "Error",
          content: response?.data?.message,
          open: true,
        });
      }
    }
  };

  const handleEvent = (val) => {
    const selectedValues = val?.map((data) => data?.id);
    setEventData(val?.map((option) => ({ id: option?.id, label: option?.label })));
    formik.setFieldValue("event_advertisements", selectedValues);
  };

  const handleStatusChange = (value) => {
    if (value) {
      formik.setFieldValue("is_active", value.value);
      setStatus(value);
    } else {
      formik.setFieldValue("is_active", null);
      setStatus(null);
    }
  };

  const handleSelectPage = async (data) => {
    formik.setFieldValue("page", data?.label);
    setPage(data?.label);
  };

  //Formik
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
  });

  return (
    <>
      <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          {/* Image */}
          <Grid item xs={12} md={12} sx={{ paddingTop: "20px !important" }}>
            <ImageUploader
              img={profileImage?.url}
              folderName={"/advertisements"}
              name={"advertisement_images"}
              fileName={"advertisement_images"}
              formik={formik}
              label="Advertisement Image (320 × 320 pixels)"
              note="Please upload an image with a width and height of 320 × 320 pixels."
              sx={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                borderRadius: "50%",
                marginBottom: "16px",
              }}
              required
            />
            {formik.touched.advertisement_images && formik.errors.advertisement_images && (
              <MDBox
                sx={{
                  fontSize: "12px",
                  color: "red",
                  marginLeft: "5px",
                }}
              >
                {formik.errors.advertisement_images}
              </MDBox>
            )}
          </Grid>

          {/* Page */}
          <Grid item xs={12} md={6} sx={{ paddingTop: "30px !important" }}>
            <MDSelectBox
              name="page"
              defaultValue={page}
              options={advertisementPage}
              handleChange={(value) => handleSelectPage(value)}
              label="Page (જ્યાં તમે જાહેરાત દેખાડવા માંગો છો તે પેજ પસંદ કરો)"
              width="100%"
              isImage={false}
              multiple={false}
              onBlur={formik.handleBlur}
            />
            {formik.touched.page && formik.errors.page && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.page}
              </MDBox>
            )}
          </Grid>

          {/* event */}
          <Grid item xs={12} md={6} sx={{ paddingTop: "30px !important" }}>
            <MDSelectBox
              name="event_advertisements"
              defaultValue={eventData ?? []}
              options={eventDataList ?? []}
              handleChange={(value) => handleEvent(value)}
              label="Events"
              width="100%"
              onBlur={formik.handleBlur}
              multiple={true}
            />
          </Grid>

          {/* Title */}
          <Grid item xs={12} md={6} sx={{ marginTop: "10px" }}>
            <MDInput
              type="text"
              name="title"
              value={formik.values.title}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label="Title"
              sx={{ width: "100%" }}
              variant="standard"
              required
            />
            {formik.touched.title && formik.errors.title && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.title}
              </MDBox>
            )}
          </Grid>

          {/* Link */}
          <Grid item xs={12} md={6} sx={{ marginTop: "10px" }}>
            <MDInput
              type="text"
              name="link"
              value={formik.values.link}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              sx={{ width: "100%" }}
              label="Link"
              variant="standard"
            />
          </Grid>

          {/* Description*/}
          <Grid item xs={12} md={12}>
            <MDTextField
              type="text"
              name="description"
              value={formik.values.description}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label="Description"
              sx={{ width: "100%" }}
              variant="standard"
              rows={4}
              multiline
            />
          </Grid>

          {/* status */}
          <Grid item xs={12} md={12} sx={{ paddingTop: "25px !important" }}>
            <MDSelectBox
              name="is_active"
              defaultValue={status}
              options={statusData}
              handleChange={(value) => handleStatusChange(value)}
              label="Status"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
              required
            />
            {formik.touched.is_active && formik.errors.is_active && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.is_active}
              </MDBox>
            )}
          </Grid>
        </Grid>

        <MDBox sx={{ width: "100%", textAlign: "center", marginTop: "40px" }}>
          <SubmitButton btnText={formIsEdit ? "Update" : "Add"} type="submit" />
        </MDBox>
      </MDBox>
    </>
  );
};
AdvertisementForm.propTypes = {
  getAdvertisementList: PropTypes.func,
};
export default AdvertisementForm;
